import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@shared/constants/query-keys';
import { request } from '@src/core/api/request';
import type { TBaseQuery } from '@src/shared/types/base-query';
import type {
  TReminder,
  TReminderLog,
  TReminderLogStatus,
} from '@src/shared/types/reminder';
import { useMutation } from '@tanstack/react-query';

export type TReminderLogsQuery = {
  channel: TReminder['notification_channel'];
  reminder_type: TReminder['type'][];
  reminder?: number | string;
  created_by: number | string;
  program: number | string;
  rule: number | string;
  stage: number | string;
  view: number | string;
  /** Filter logs by delivery status (repeat param for multiple values). */
  status?: TReminderLogStatus[];
} & TBaseQuery;

export type TReminderLogsPayload = {
  name: string;
  content: string;
  type: string;
  notification_channel: string;
  members?: number[];
  attachments?: number[];
  leads?: number[];
  students?: number[];
  date?: string;
  frequency?: number | string;
  frequency_count?: number;
  trigger_type?: string;
  variables?: Record<string, string>;
  is_rule_achieved?: boolean;
  rule?: number | string;
  stage?: number | string;
  program?: number | string;
  question?: number | string;
  template?: number | string;
  periodic_task?: number | string;
  view?: number | string;
};

const reminderLogsApi = {
  ...createCrudService<TReminderLog, TReminderLogsQuery, TReminderLogsPayload>({
    queryKey: [QUERY_KEYS.getRemindersLogs],
    url: 'reminders/logs',
  }),
  useResendReminderLog: () =>
    useMutation({
      mutationFn: async (ids: number[]) =>
        await request<void>({
          url: `reminders/logs/resend/`,
          method: 'POST',
          body: { ids },
        }),
    }),
};

export default reminderLogsApi;
